import { render, staticRenderFns } from "./SelectStatusGroup.vue?vue&type=template&id=e58b4288"
import script from "./SelectStatusGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectStatusGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e58b4288')) {
      api.createRecord('e58b4288', component.options)
    } else {
      api.reload('e58b4288', component.options)
    }
    module.hot.accept("./SelectStatusGroup.vue?vue&type=template&id=e58b4288", function () {
      api.rerender('e58b4288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/group/status/components/SelectStatusGroup.vue"
export default component.exports